import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { AUTH_SERVICE } from '@core-features/core';
import { CopilotChat } from '@copilotkit/angular';
import { CHAT_HUB_AGENT_ID } from './app.config';
import { PalchatChatInputComponent } from './palchat-chat-input.component';
import { PalchatStatusComponent } from './palchat-status.component';
import { EmbedBridgeService } from './embed-bridge.service';
import { registerContactSupportTool } from './contact-support/contact-support-tool';

@Component({
  selector: 'pc-root',
  imports: [CopilotChat],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '(document:keydown.escape)': 'embedBridge.requestClose()',
  },
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private readonly _authService = inject(AUTH_SERVICE);

  protected readonly embedBridge = inject(EmbedBridgeService);
  protected readonly agentId = CHAT_HUB_AGENT_ID;
  protected readonly statusComponent = PalchatStatusComponent;
  protected readonly chatInputComponent = PalchatChatInputComponent;
  protected readonly $isAuthenticated = this._authService.$isAuthenticated;

  constructor() {
    registerContactSupportTool();
  }

  ngOnInit(): void {
    this.embedBridge.notifyReady();
  }
}
